import React from 'react'
import ReactDOM from "react-dom";

export const SvgIcons = (props) => {
    if (props.pageshow === "rightArrow") {
        return (
            <svg width={props.size} height={props.size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="30" r="30" fill="#F9E6EB" />
                <path fillRule="evenodd" clipRule="evenodd" d="M24.3383 14.4075C22.7946 12.8272 20.2621 12.7974 18.6818 14.3411C17.1015 15.8847 17.0717 18.4172 18.6154 19.9975L24.5652 26.0888L9.6174 26.0223C7.40828 26.0125 5.60947 27.7953 5.59965 30.0045C5.58983 32.2136 7.3727 34.0124 9.58182 34.0222L24.4517 34.0883L18.923 40.1453C17.4336 41.7769 17.549 44.3069 19.1806 45.7963C20.8122 47.2856 23.3422 47.1703 24.8316 45.5387L36.7362 32.4967C38.1655 30.9309 38.1248 28.5217 36.6433 27.005L24.3383 14.4075Z" fill="#0A2540" />
                <path d="M45.929 9.83801V48.9237" stroke="#E32C5E" strokeWidth="6" strokeLinecap="round" />
            </svg>
        )
    }
    if (props.pageshow === "timeIcon") {
        return (
            <svg width={props.size} height={props.size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="30" r="30" fill="#F9E6EB" />
                <circle cx="30.4" cy="30.4" r="19.4" stroke="#0A2540" strokeWidth="6" />
                <path d="M29.5996 21.6L29.7259 32.4184L37.9387 32.1654" stroke="#E32C5E" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        )
    }
    if (props.pageshow === "searchIcon") {
        return (
            <svg width={props.size} height={props.size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30.4" cy="30.4" r="30.4" fill="#F9E6EB" />
                <path d="M47.5765 26.8C47.5765 33.8151 42.0165 39.4 35.2824 39.4C28.5483 39.4 22.9883 33.8151 22.9883 26.8C22.9883 19.7849 28.5483 14.2 35.2824 14.2C42.0165 14.2 47.5765 19.7849 47.5765 26.8Z" stroke="#0A2540" strokeWidth="6" />
                <path d="M20.7721 39.2L11.9219 47.0114" stroke="#E32C5E" strokeWidth="6" strokeLinecap="round" />
            </svg>
        )
    }
    if (props.pageshow === "bondingIcon") {
        return (
            <svg width={props.size} height={props.size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30.5996" cy="30.6" r="30" fill="#F9E6EB" />
                <ellipse cx="31.0126" cy="9.22829" rx="6.4" ry="6.4" transform="rotate(20 31.0126 9.22829)" fill="#0A2540" />
                <circle cx="48.2274" cy="36.7779" r="6.4" transform="rotate(20 48.2274 36.7779)" fill="#0A2540" />
                <ellipse cx="17.331" cy="46.816" rx="6.4" ry="6.4" transform="rotate(20 17.331 46.816)" fill="#0A2540" />
                <path d="M36.6006 19.0498L41.1222 28.2322" stroke="#E32C5E" strokeWidth="6" strokeLinecap="round" />
                <path d="M27.9387 42.8512L37.3048 38.7235" stroke="#E32C5E" strokeWidth="6" strokeLinecap="round" />
            </svg>
        )
    }

    if (props.pageshow === "email") {
        return (
            <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM17.4063 6.66667L11.9956 10.9442L6.40878 6.66667H17.4063ZM5.85189 17.3333H17.963V8.33578L12.477 12.6998C12.3257 12.8193 12.167 12.8793 11.9842 12.8793C11.8057 12.8793 11.5842 12.8221 11.4346 12.7077L5.85189 8.47322V17.3333Z" fill="#E32C5E" />
            </svg>
        )
    }

    if (props.pageshow === "phone") {
        return (
            <svg width={props.size} height={props.size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M3.51344 3.51602C8.19902 -1.17101 15.797 -1.17214 20.484 3.51344C22.7346 5.76335 23.9994 8.8151 24 11.9974C24.0007 15.1803 22.7369 18.233 20.4866 20.484C15.801 25.171 8.20305 25.1722 3.51602 20.4866C-1.17101 15.801 -1.17214 8.20305 3.51344 3.51602ZM18.172 16.7175L18.1736 16.7159C18.3715 16.517 18.3708 16.1954 18.172 15.9975L15.9199 13.7415L15.9183 13.7399C15.7195 13.542 15.3979 13.5427 15.1999 13.7415L13.924 15.0375C13.5522 15.4067 12.9697 15.4572 12.54 15.1575C11.7963 14.6375 11.1003 14.0525 10.46 13.4095C9.88572 12.8373 9.35739 12.2207 8.87997 11.5655C8.56558 11.1354 8.6132 10.5401 8.99195 10.1655L10.312 8.84547L10.3135 8.84388C10.5115 8.64508 10.5108 8.32342 10.312 8.12547L8.06397 5.87749L8.06238 5.87589C7.86358 5.67794 7.54192 5.67864 7.34397 5.87749L6.63199 6.58947C5.76794 7.43941 5.45824 8.70452 5.83197 9.85746C6.15799 10.8389 6.61835 11.7704 7.19997 12.6255C7.73172 13.4201 8.34138 14.1598 9.01999 14.8335C9.75752 15.5755 10.5745 16.2341 11.456 16.7975C12.4048 17.4207 13.4473 17.8879 14.544 18.1815C15.6325 18.4413 16.7777 18.1137 17.564 17.3175L18.172 16.7135V16.7175Z" fill="#E32C5E" />
            </svg>
        )
    }

    if (props.pageshow === "hMenu") {
        return (
            <svg viewBox="0 0 100 80" width={props.size} height={props.size}>
            <rect width="100" height="20"></rect>
            <rect y="30" width="100" height="20"></rect>
            <rect y="60" width="100" height="20"></rect>
            </svg>
        )
        }

}
